import React from 'react';

import { withTranslation } from 'react-i18next';
import { Tooltip } from 'antd';

import('./HorizontalVulnerabilityScale.sass');

interface HorizontalVulnerabilityScaleProps {
	vulnerabilities: Array<{
		id: string | null;
		name: string;
		vulnerability: number | null;
	}>;
	scenarios: Array<{
		id: string;
		name: string;
	}>;
	scenario: {
		id: string;
		name: string;
	} | null;
	t: (key: string) => string;
}

class HorizontalVulnerabilityScale extends React.Component<HorizontalVulnerabilityScaleProps> {
	render() {
		const { vulnerabilities, t } = this.props;

		return (
			<div
				className="HorizontalVulnerabilityScale"
				style={{ width: '500px' }}
			>
				<div className="top noselection">
					{t('pages.scenarios.context_best')}
				</div>
				<div className="middle">
					<hr />
				</div>
				<div className="bottom noselection">
					{t('pages.scenarios.context_worse')}
				</div>

				{vulnerabilities.map((v) => {
					return v.vulnerability !== null ? <Tooltip
						placement="top"
						key={(v.id || "baseline")}
						title={<div>{v.name || t("models.scenario.baseline")}</div>}
					>
						<div
							id={'initial_bar_marker'}
							style={{ left: (v.vulnerability) + '%' }}
						></div>
					</Tooltip> : null
				})}

				{vulnerabilities.map((v) => {
					const isCurrent = v.id == this.props.scenario?.id
					return isCurrent && v.vulnerability !== null ? <Tooltip
						placement="top"
						key={isCurrent ? "current" : (v.id || "baseline")}
						title={<div>{v.name || t("models.scenario.baseline")}</div>}
					>
						<div
							id={'bar_marker'}
							style={{ left: (v.vulnerability) + '%' }}
						></div>
					</Tooltip> : null
				})}
			</div>
		);
	}
}

export default withTranslation()(HorizontalVulnerabilityScale);
